import L1 from "../animation/marketing/Digicots-digital-marketing.json"
import L2 from "../animation/marketing/Project-management.json"
import L3 from "../animation/marketing/Creation-marketing-content.json"
import Lottie from 'lottie-react';



// Data array for marketing sections
const marketingSections = [
    {
        id: 1,
        reverse: false,
        smallHeader: "Creation of marketing content",
        title: "In marketing, </br> CONTENT IS KING",
        description: [
            "Each advertising channel has its own language. Our experts in content marketing and storytelling design tailor-made advertising messages, perfectly adapted to your identity and capable of effectively reaching your target.",
            "Whether texts, images or videos, we create for you marketing content, which highlight your message in an emotional and visual way."
        ],
        src: L3,
        alt: "Multi-channel marketing strategy"
    },
    {
        id: 2,
        reverse: true,
        smallHeader: "Project management",
        title: "No time or lack of knowledge – WHO TAKES CARE OF IT?",
        description: [
            "Production of content, production of advertising materials, execution of campaigns. Our agency takes care of all this,. You decide the intensity of our support: from one-off advice to support for your 360° marketing, everything is possible.",
            "During regular meetings and workshops, you make strategic decisions with us which we then implement within the framework of a marketing plan. "
        ],
        src: L2,
        alt: "Data analysis and marketing optimization"
    },

    {
        id: 3,
        reverse: false,
        smallHeader: "Digital Marketing",
        title: "Focus on your business, our agency TAKES CARE OF YOUR MARKETING",
        description: [
            "A strategy of digital marketing well thought out defines which advertising channels to use, with which campaigns and which content.",
            "But its implementation requires a lot of time, resources and expertise - resources that small and medium-sized businesses do not always have."
        ],
        src: L1,
        alt: "Team meeting discussing digital marketing strategy"
    }
];

// Reusable Marketing Section Component
const MarketingSection = ({ section }) => {
    const { reverse, smallHeader, title, description, src } = section;

    return (
        <div className={`flex items-center justify-between py-10 gap-10 xl:px-35 md:px-10 flex-col md:flex-row ${reverse ? 'md:flex-row-reverse' : ''}`}>
            {/* Image side */}
            <div className='md:w-[50%] w-[90vw] h-[60vh] overflow-hidden md:h-full flex items-center justify-center'>
                <div className='w-full scale-[1.5]'>
                    <Lottie animationData={src} loop={true} />
                </div>
            </div>

            {/* Content side */}
            <div className={`md:w-1/2 px-10 md:px-0 h-full flex flex-col justify-center ${reverse ? 'md:pr-12' : 'md:pl-12'}`}>
                <div className=''>
                    {/* Small header */}
                    <p className='text-[#EE005B] text-sm font-medium mb-6 tracking-wide'>
                        {smallHeader}
                    </p>

                    {/* Main heading */}
                    <h2 className='text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-8 leading-tight' dangerouslySetInnerHTML={{ __html: title }}>
                    </h2>

                    {/* Description */}
                    <div className='text-gray-600 dark:text-gray-300 text-lg leading-relaxed'>
                        {description.map((paragraph, index) => (
                            <p key={index} className={index < description.length - 1 ? 'mb-4' : ''}>
                                {
                                    paragraph
                                }
                            </p>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const ScrollStackAnimation = () => {



    return (
        <div className=' w-full dark:bg-zinc-900 bg-white dark:text-white relative z-20 pointer-events-auto'>

            <div className=' w-full bg-zinc-100 dark:bg-black z-20 left-0 rounded-t-4xl pt-15'>
            <div className='w-full '>
                <div className='md:px-35 px-10 py-20 md:ml-10 text-center'>
                    <h1 className='md:text-6xl text-4xl font-bold mb-4 '>360° Marketing</h1>
                    <p className='text-lg'>Service 360° marketing for businesses: from the definition of media plan to support campaigns targeted and measurable.</p>
                </div>
            </div>
                {marketingSections.map((section) => (
                    <MarketingSection key={section.id} section={section} />
                ))}
            </div>

        </div>

    )
}

export default ScrollStackAnimation